<template>
  <!--  style="
      filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
      -webkit-filter: grayscale(100%);
    " -->
  <div class="pc_index">
    <pc-header @search="headerSearch"></pc-header>
    <!-- <div class="pc_index_header">
      <div class="pc_index_head">
        <div class="pc_index_head_left" @click="toHome">
     
          <div class="home"><van-icon name="wap-home-o" /> {{ $t('message.home.home_page') }}</div>
        </div>
        <div class="pc_index_head_right">
          <div
            v-if="isShowUser"
            @click="$router.push('/user')"
            class="avaterDiv"
            @mouseenter="handleMouseEnterS"
            @mouseleave="handleMouseLeaveS"
          >
            <img
              :src="
                userInfo.headImgUrl
                  ? userInfo.headImgUrl
                  : 'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/index.png'
              "
              class="avater"
            />
            <span>{{ userInfo.nickName }}</span>

            <div class="select" v-show="selectShow" @mouseenter="handleMouseEnterS">
              <div class="personal_details" @click="$router.push('/user')">个人信息</div>
              <div class="log_out" @click="goActie">退出登录</div>
            </div>
          </div>
          <div v-else class="avaterDiv">
            <img
              src="https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/index.png"
              class="avater"
            />
            <span @click="$router.push('/login')">{{ $t('message.login.sign') }}</span>
            <span @click="$router.push('/login/register')">{{ $t('message.login.register') }}</span>
          </div>
          <div class="bo" @click="languageChang">
            <div class="word">
              <div>中</div>
              <div>En</div>
            </div>
            <div class="btn" :class="right ? 'aas' : ''" ref="qiehuan">中</div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="pc_index_main">
      <div class="activity_swiper" style="padding-top: 30px">
        <van-swipe :autoplay="5000" indicator-color="#3562FF" style="width: 100%" height="200">
          <van-swipe-item v-for="(item, index) in imgList" :key="index">
            <img
              :src="item.pcBannerImage"
              alt=""
              title=""
              @click="imgUrlClick(item)"
              style="width: 100%; height: 200px; border-radius: 16px"
            />
          </van-swipe-item>
        </van-swipe>
      </div>
      <!-- 公告 -->
      <div class="annoucent" v-if="announListShow">
        <div class="annoucent_li">
          <van-notice-bar left-icon="volume-o" :scrollable="false">
            <van-swipe vertical indicator-color="#3562FF" :autoplay="6000" :show-indicators="false">
              <van-swipe-item
                v-for="(item, index) in announList"
                :key="index"
                @click="announListClick(item)"
              >
                <!-- <van-icon name="volume-o" color="#3562FF" size="16" /> -->
                <p
                  v-html="item.popupWindowMessage"
                  style="margin: 0"
                  v-if="item.awayTo === 1 || item.awayTo === 3"
                ></p>
                <p v-if="item.awayTo === 2" style="margin: 0">{{ item.title }}</p>
                <!-- <van-icon name="arrow" size="16" color="#999999" /> -->
              </van-swipe-item>
            </van-swipe>
          </van-notice-bar>
        </div>
      </div>

      <div class="page_data">
        <!-- 活动状态 -->
        <!-- <div
          style="display: flex; justify-content: space-between"
          id="2"
          v-if="activitingList.length !== 0"
        >
          <div class="active_title">
            <img src="./images/activiting.png" />
          </div>
        </div> -->
        <!-- 活动状态 -->
        <div class="activity_state">
          <div
            class="activity_state_item"
            :class="{
              activity_state_active: activityStateClass == ''
            }"
            @click="clickSelectState('')"
          >
            <!-- 全部 -->
            {{ $t('message.home.i_all') }}
          </div>

          <div
            class="activity_state_item"
            :class="{
              activity_state_active: activityStateClass == 2
            }"
            @click="clickSelectState(2)"
          >
            <!-- 进行中 -->
            {{ $t('message.home.i_pro') }}
          </div>

          <div
            class="activity_state_item"
            :class="{
              activity_state_active: activityStateClass == 1
            }"
            @click="clickSelectState(1)"
          >
            <!-- 待开始 -->
            {{ $t('message.home.t_start') }}
          </div>

          <div
            class="activity_state_item"
            :class="{
              activity_state_active: activityStateClass == 3
            }"
            @click="clickSelectState(3)"
          >
            <!-- 已结束 -->
            {{ $t('message.home.ended') }}
          </div>
        </div>
        <div style="display: flex; justify-content: left; flex-wrap: wrap">
          <div
            class="page_data_item"
            @click="activityClick(item)"
            v-for="(item, index) in pageData"
            :key="index"
          >
            <div
              class="item_box"
              @mouseenter="handleMouseEnter(item.id)"
              @mouseleave="handleMouseLeave(item.id)"
            >
              <div class="page_data_item_img">
                <img v-if="item.pcActiveImageList" :src="item.pcActiveImageList[0]" alt="" />
                <!-- // 遮罩层 -->
                <div class="mask1" v-show="item.isShow"></div>

                <div v-show="item.isShow" class="page_data_item_title">{{ item.activeName }}</div>
              </div>
              <div class="page_data_item_organizer">
                <div class="left" v-if="!item.isShowS">
                  <span>{{ $t('message.cpn.coll_works') }}:</span>
                  <span v-for="(kind, index) in item.contributeTypeList" :key="index">
                    <!-- {{ getKindValue(kind) }} -->
                    <span v-if="kind == 1">{{ $t('message.explain.g_txt') }}</span>
                    <span v-if="kind == 2">{{ $t('message.explain.voide') }}</span>
                    <span v-if="kind == 3">{{ $t('message.explain.photo') }}</span>
                    <span v-if="kind == 4">{{ $t('message.explain.pain') }}</span>
                    <span v-if="kind == 5">{{ $t('message.explain.animation') }}</span>
                    <span v-if="kind == 6">{{ $t('message.explain.sci_work') }}</span>
                    <span v-if="index !== item.contributeTypeList.length - 1">、</span>
                  </span>
                </div>

                <div class="right_box">
                  <!-- 查看人数 -->
                  <div class="center" v-if="!item.isShowS">
                    <van-icon name="eye-o" />
                    {{ item.pageViews | pageViews }}
                  </div>
                  <!-- 参与人数 -->
                  <div v-if="!item.isShowS">
                    <div v-if="!item.notSignUp" class="right">
                      <van-icon name="friends-o" size="15" /><span style="margin-left: 5px">{{
                        item.numberPeople | filtersNumber
                      }}</span
                      ><span>{{ $t('message.cpn.people') }}</span>
                    </div>
                    <div v-else class="right">
                      <van-icon name="friends-o" size="15" /><span style="margin-left: 5px">{{
                        item.signUpNumber ? item.signUpNumber : 0
                      }}</span
                      ><span>{{ $t('message.cpn.people') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div
          style="display: flex; justify-content: space-between"
          id="1"
          v-if="beStartList.length !== 0"
        >
          <div class="active_title">
            <img src="./images/beStart.png" />
          </div>
        </div> -->
        <!-- <div style="display: flex; justify-content: left; flex-wrap: wrap">
          <div
            class="page_data_item"
            @click="activityClick(item)"
            @mouseenter="handleMouseEnter(item.id)"
            @mouseleave="handleMouseLeave(item.id)"
            v-for="(item, index) in beStartList"
            :key="index"
          >
            <div class="page_data_item_img">
              <img v-if="item.pcActiveImageList" :src="item.pcActiveImageList[0]" alt="" />
              <div class="mask"></div>
              <div v-show="item.isShow">
                <div class="img_number" v-if="!item.notSignUp">
                  <van-icon name="friends-o" />
                  <em>{{ item.numberPeople }}</em
                  >{{ $t('message.cpn.people') }}
                </div>
                <div class="img_number" v-else>
                  <van-icon name="friends-o" />
                  <em>{{ item.signUpNumber }}</em
                  >{{ $t('message.login.peop_come') }}
                </div>
              </div>
              <div class="page_data_item_title">{{ item.activeName }}</div>
            </div>
            <div class="page_data_item_organizer">
              <div class="left" v-if="!item.isShowS">
                <span>{{ $t('message.cpn.coll_works') }}:</span>
                <span v-for="(kind, index) in item.contributeTypeList" :key="index">
           
                  <span v-if="kind == 1">{{ $t('message.explain.g_txt') }}</span>
                  <span v-if="kind == 2">{{ $t('message.explain.voide') }}</span>
                  <span v-if="kind == 3">{{ $t('message.explain.photo') }}</span>
                  <span v-if="kind == 4">{{ $t('message.explain.pain') }}</span>
                  <span v-if="kind == 5">{{ $t('message.explain.animation') }}</span>
                  <span v-if="kind == 6">{{ $t('message.explain.sci_work') }}</span>
                  <span v-if="index !== item.contributeTypeList.length - 1">、</span>
                </span>
              </div>
     

              <div class="center"></div>
              <div v-if="!item.isShowS">
                <div v-if="!item.notSignUp" class="right">
                  <van-icon name="friends-o" size="15" /><span style="margin-left: 5px">{{
                    item.numberPeople
                  }}</span
                  ><span>{{ $t('message.cpn.people') }}</span>
                </div>
                <div v-else class="right">
                  <van-icon name="friends-o" size="15" /><span style="margin-left: 5px">{{
                    item.signUpNumber
                  }}</span
                  ><span>{{ $t('message.cpn.people') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div
          style="display: flex; justify-content: space-between"
          id="3"
          v-if="overList.length !== 0"
        >
          <div class="active_title">
            <img src="./images/over.png" />
          </div>
        </div> -->
        <!-- <div style="display: flex; justify-content: left; flex-wrap: wrap">
          <div
            class="page_data_item"
            @click="activityClick(item)"
            @mouseenter="handleMouseEnter(item.id)"
            @mouseleave="handleMouseLeave(item.id)"
            v-for="(item, index) in overList"
            :key="index"
          >
            <div class="page_data_item_img">
              <img v-if="item.pcActiveImageList" :src="item.pcActiveImageList[0]" alt="" />
              <div class="mask1" v-show="item.isShow"></div>

              <div v-show="item.isShow" class="page_data_item_title">{{ item.activeName }}</div>
            </div>
            <div class="page_data_item_organizer">
              <div class="left" v-if="!item.isShowS">
                <span>{{ $t('message.cpn.coll_works') }}:</span>
                <span v-for="(kind, index) in item.contributeTypeList" :key="index">
                  <span v-if="kind == 1">{{ $t('message.explain.g_txt') }}</span>
                  <span v-if="kind == 2">{{ $t('message.explain.voide') }}</span>
                  <span v-if="kind == 3">{{ $t('message.explain.photo') }}</span>
                  <span v-if="kind == 4">{{ $t('message.explain.pain') }}</span>
                  <span v-if="kind == 5">{{ $t('message.explain.animation') }}</span>
                  <span v-if="kind == 6">{{ $t('message.explain.sci_work') }}</span>
                  <span v-if="index !== item.contributeTypeList.length - 1">、</span>
                </span>
              </div>
   
              <div class="center"></div>
              <div v-if="!item.isShowS">
                <div v-if="!item.notSignUp" class="right">
                  <van-icon name="friends-o" size="15" /><span style="margin-left: 5px">{{
                    item.numberPeople
                  }}</span
                  ><span>{{ $t('message.cpn.people') }}</span>
                </div>
                <div v-else class="right">
                  <van-icon name="friends-o" size="15" /><span style="margin-left: 5px">{{
                    item.signUpNumber
                  }}</span
                  ><span>{{ $t('message.cpn.people') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
      <van-dialog
        v-model="showDia"
        title="公告"
        confirmButtonText="确认"
        confirmButtonColor="#3360FF"
      >
        <div class="dia_show">
          <p>{{ diaData.popupWindowMessage }}</p>
          <div class="image_box">
            <img :src="diaData.image" v-if="diaData.image" />
          </div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
const defaultQuery = Object.freeze({
  pageNum: 0,
  pageSize: 300,
  language: 'zhcn',
  activeState: ''
})

import { wexinShare } from '@/utils/wxshare'
import { wxShare } from '@/api/common'
import { getCookie } from '@/utils/cookie'
import { clearCookie } from '@/utils/cookie'
import { Toast } from 'vant'
import { apiUser } from '@/api/user.js'
import { getActivityBanner, getActivityAllList, annouAllList } from '@/api/activity'
// //判断手机端和pc端
// import device from 'current-device'
// import pcIndex from './cpn/index.vue'
import pcHeader from '../../../components/pcHeader.vue'
export default {
  // components: { pcIndex },
  name: 'Activity',
  components: {
    pcHeader
  },
  data() {
    return {
      diaData: {},
      showDia: false,
      announListShow: false,
      announList: [],
      imgList: [],
      btnIndex: 0,
      btnList: [
        {
          value: this.$t('message.home.i_pro'),
          id: '2',
          img: './images/active.png',
          imgActive: './images/activiting.png'
        },
        {
          value: this.$t('message.home.t_start'),
          id: '1',
          img: 'images/beStart.png',
          imgActive: 'images/beStarting.png'
        },
        {
          value: this.$t('message.home.ended'),
          id: '3',
          img: './images/over.png',
          imgActive: './images/overing.png'
        }
      ],
      kindList: [
        {
          value: '1',
          label: this.$t('message.explain.g_txt')
        },
        {
          value: '2',
          label: this.$t('message.explain.voide')
        },
        {
          value: '3',
          label: this.$t('message.explain.photo')
        },
        {
          value: '4',
          label: this.$t('message.explain.pain')
        },
        {
          value: '5',
          label: this.$t('message.explain.animation')
        },
        {
          value: '6',
          label: this.$t('message.explain.sci_work')
        }
      ],
      selectValue: sessionStorage.getItem('lang'),
      right: sessionStorage.getItem('bl'),
      queryInfo: { ...defaultQuery },
      pageData: [],
      isWap: true,
      // 默认选中的状态
      activeState: this.$t('message.home.i_pro'),
      // 用户信息
      userInfo: {},
      isShowUser: false,
      selectShow: false, //
      activityStateClass: '' // 活动状态选择
    }
  },
  filters: {
    filtersNumber(val) {
      let value = ''
      if (val) {
        value = val * 3
      }
      return value
    },
    pageViews(val) {
      // 转化为字符串
      let str = ''
      // 判断是否破万
      if (val >= 10000) {
        // 除10000 得到w单位的数字
        str = val / 10000
        //  保留一位小数点 并且添加w单位
        str = str.toFixed(1) + 'w'
      } else {
        str = val
      }

      return str
    }
  },
  computed: {
    // 进行中
    activitingList() {
      let arr = []
      this.pageData.forEach((item) => {
        if (item.activeState === 2) arr.push(item)
      })
      return arr
    },
    // 待开始
    beStartList() {
      let arr = []
      this.pageData.forEach((item) => {
        if (item.activeState === 1) arr.push(item)
      })
      return arr
    },
    // 已结束
    overList() {
      let arr = []
      this.pageData.forEach((item) => {
        if (item.activeState === 3) arr.push(item)
      })
      return arr
    }
  },

  created() {
    if (sessionStorage.getItem('schemaCac')) {
      console.log('cac')
    } else {
      sessionStorage.setItem('schemaCac', 'true')
      if (sessionStorage.getItem('schema') == 'cac') {
        this.$router.push({
          path: '/activity/works?id=8'
        })
      }
    }

    this.getBannerList()
    this.search()
    this.getannouAll()
    this.weixin()

    // if (this.$route.query.lang) {
    //   if (this.$route.query.lang == 'zhcn') {
    //     sessionStorage.setItem('lang', this.$route.query.lang)
    //     sessionStorage.setItem('bl', false)
    //   }
    //   if (this.$route.query.lang == 'en') {
    //     sessionStorage.setItem('lang', this.$route.query.lang)
    //     sessionStorage.setItem('bl', true)
    //   }
    // }
    // let token = getCookie('token')
    // if (token) {
    //   this.getUser()
    //   this.isShowUser = true
    // } else {
    //   this.isShowUser = false
    // }
  },
  mounted() {
    // if (sessionStorage.getItem('bl') == 'false') {
    //   this.right = true
    // }
    // if (sessionStorage.getItem('bl') == 'true') {
    //   this.right = false
    // }
    // this.languageChang()
  },
  methods: {
    // 选择状态
    clickSelectState(state) {
      this.activityStateClass = state
      this.queryInfo.activeState = state
      this.search()
    },
    headerSearch() {
      this.search()
      this.getannouAll()
    },
    //语言切换
    // languageChang() {
    //   sessionStorage.setItem('bl', !this.right)
    //   this.right = !this.right
    //   let tt = ''
    //   if (this.right == false) {
    //     this.context = '中'
    //     tt = 'zhcn'
    //     this.queryInfo.language = tt
    //   }
    //   if (this.right == true) {
    //     this.context = 'En'
    //     tt = 'en'
    //     this.queryInfo.language = tt
    //   }
    //   this.langChange(tt)
    //   this.$refs.qiehuan.innerHTML = this.context
    //   this.search()
    //   this.getannouAll()
    // },
    // langChange(value) {
    //   this.selectValue = value
    //   // console.log(this.selectValue)
    //   sessionStorage.setItem('lang', this.selectValue)
    //   this.$i18n.locale = this.selectValue
    // },
    // 获取登录信息
    // async getUser() {
    //   const { data: res } = await apiUser()
    //   if (res.resultCode === 200) {
    //     this.userInfo = res.data
    //   }
    // },
    // 退出登录
    // goActie() {
    //   clearCookie('token')
    //   clearCookie('userId')
    //   Toast.success(this.$t('message.user.logged'))
    //   setTimeout(() => {
    //     this.$router.push({
    //       name: 'Activity'
    //     })
    //   }, 1000)
    // },
    // 鼠标移入头像
    // handleMouseEnterS() {
    //   this.selectShow = true
    //   // console.log('移入了')
    // },
    // // 鼠标移出头像
    // handleMouseLeaveS() {
    //   this.selectShow = false
    //   // console.log('移出了')
    // },
    // // 去首页
    // toHome() {
    //   this.$router.push('/')
    // },
    // 微信分享
    async weixin() {
      var urls = window.location.href
      const { data: res } = await wxShare({ url: urls })
      if (res.code === 102400) {
        var obj = {
          appId: res.appId,
          nonceStr: res.nonceStr,
          signature: res.signature,
          timestamp: res.timestamp,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
        }
        let shareData = {
          title: this.$t('message.home.yuanjing'), // 分享标题
          desc: this.$t('message.home.p_yuanjing'),
          link: urls,
          // link: window.location.href,
          imgUrl:
            'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/%E5%85%83%E6%99%AF%E4%BA%91logo-01.png' // 分享图标
        }
        wexinShare(obj, shareData)
      }
    },
    // 公告栏点击
    announListClick(row) {
      if (row.awayTo === 1) {
        this.diaData = row
        this.showDia = true
      } else if (row.awayTo === 2) {
        this.$router.push({
          name: 'textShow',
          query: { id: row.id }
        })
      } else if (row.awayTo === 3) {
        window.open(row.noticeUrl, '_self')
      }
    },
    // 查询公告栏
    async getannouAll() {
      const { data: res } = await annouAllList()
      if (res.resultCode === 200) {
        this.announList = res.data
        if (res.data != undefined && res.data.length > 0) {
          this.announListShow = true
        } else {
          this.announListShow = false
        }
      }
    },
    // 每一项鼠标移入处理事件
    handleMouseEnter(id) {
      this.pageData.forEach((item) => {
        if (item.id === id) item.isShow = true
      })
    },
    handleMouseLeave(id) {
      this.pageData.forEach((item) => {
        if (item.id === id) item.isShow = false
      })
    },
    // 根据作品类型列表码值得到中文名
    getKindValue(kind) {
      let temp = ''
      this.kindList.forEach((item) => {
        if (item.value === kind) temp = item.label
      })
      return temp
    },
    // 点击不同照片跳转不同详情页
    imgUrlClick(row) {
      window.open(row.url, '_self')
    },
    // 页面new活动
    newActivityClick() {
      window.open('http://zxp.mlyunai.com/?aID=62eb2eb1fbea2d6a83147976#/')
    },
    // 活动跳转
    activityClick(row) {
      console.log(row)
      // if(row){
      //   return
      // }
      if (row.activeState == 1) {
        this.$router.push({
          path: '/activity/details',
          query: { id: row.id }
        })
        return
      }
      if (row.newActivityState == 0) {
        // window.open('http://zxp.mlyunai.com/?aID=62eb2eb1fbea2d6a83147976#/')
        // window.open('https://cac.cnsmeta.cn/activity/details?id=8')
        window.open('https://cac.cnsmeta.cn/activity/works?id=8')
      } else if (row.newActivityState == 1) {
        window.open('https://h5.cnsmeta.cn/activity/works?id=106')
      } else if (row.newActivityState == 2) {
        window.open('https://h5.cnsmeta.cn/activity/works?id=105')
      } else {
        this.$router.push({
          name: 'Works',
          query: { id: row.id }
        })
      }
      // this.$router.push({
      //   name: 'Works',
      //   query: { id: row.id }
      // })
    },
    // 点击不同按钮展示不同状态活动
    btnClcik(index, item) {
      this.activeState = item
      this.btnIndex = index
      // this.search()
    },
    // 初始化+查找
    async search() {
      this.queryInfo.language =
        sessionStorage.getItem('lang') == undefined ? 'zhcn' : sessionStorage.getItem('lang')
      const { data: res } = await getActivityAllList(this.queryInfo)
      if (res.resultCode === 200) {
        // console.log(res.data.list);
        this.pageData = res.data.list
        const schema = sessionStorage.getItem('schema')
        if (schema != 'cac' && (this.activityStateClass == '' || this.activityStateClass == 3)) {
          this.pageData.splice(0, 0, {
            // 展示图片路径
            // pcActiveImageList: [
            //   'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/background.jpg'
            // ],
            pcActiveImageList: [
              'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/k4kc6UP4-%E6%96%B0%E7%9A%84H5%E5%B0%8Fbanner.jpg'
            ],
            newActivityState: 0, // 用来跳转的
            activeState: 3, // 这个状态是正在进行中
            isShowS: true
          })
        } else if (
          schema == 'cac' &&
          (this.activityStateClass == '' || this.activityStateClass == 2)
        ) {
          this.pageData.splice(1, 0, {
            // 展示图片路径
            pcActiveImageList: [
              'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/60Di9Ckd-%E7%94%BB%E6%84%8F356%EF%BC%8C200.jpg?Expires=4822194597&OSSAccessKeyId=LTAI5tMgiCbpnVnpqhL4hWB2&Signature=ByDgXF6wOkESh0N0HTnbZkYoVH0%3D'
            ],
            newActivityState: 1, // 用来跳转的
            activeState: 2, // 这个状态是正在进行中
            isShowS: true
          })
        }
        if (schema == 'cac' && (this.activityStateClass == '' || this.activityStateClass == 3)) {
          this.pageData.splice(2, 0, {
            // 展示图片路径

            pcActiveImageList: [
              'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/39f51348-banner750%EF%BC%8C200B.jpg?Expires=4822194597&OSSAccessKeyId=LTAI5tMgiCbpnVnpqhL4hWB2&Signature=DVwOtX8TWKhbtfo%2FF7yGAmN5qP8%3D'
            ],
            newActivityState: 2, // 用来跳转的
            activeState: 3, //
            isShowS: true
          })
        }
        // console.log(this.pageData)
      }
    },
    // 获取轮播图
    async getBannerList() {
      const { data: res } = await getActivityBanner()
      if (res.resultCode === 200) {
        this.imgList = res.data
      }
    }
  }
}
</script>

<style lang="less" scoped>
a {
  text-decoration: none; /* 去除默认的下划线 */
  color: #000; /* 去除默认的颜色和点击后变化的颜色 */
}
@font-face {
  font-family: YouSheBiaoTiHei;
  src: url('../../../../static/font/YouSheBiaoTiHei-2.ttf');
  font-weight: normal;
  font-style: normal;
}
.dia_show {
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  .image_box {
    display: flex;
    justify-content: center;
    img {
      width: 200px;
      height: 200px;
      object-fit: contain;
      border-radius: 2px;
      display: block;
      margin: 10px auto;
      text-align: center;
    }
  }

  p {
    color: #1a1a1a;
    font-size: 14px;
    line-height: 1.5em;
    font-weight: 400;
  }
}

.annoucent {
  /deep/.van-swipe-item {
    display: flex;
    align-items: center;
  }
  .notice-swipe {
    height: 40px;
    line-height: 40px;
  }
  .van-swipe {
    height: 40px;

    .van-swipe-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      overflow: hidden;

      i {
        width: 16px;
      }

      p {
        flex: 1;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        margin: 0 12px;
        font-size: 14px;
        font-weight: 400;
      }
    }
  }
}

.pc_index {
  box-sizing: border-box;
  margin: 0px auto;
  margin-right: calc(100% - 100vw);

  .pc_index_header {
    width: 100%;
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.1);
    border-radius: 0px;
    background-color: #ffffff;
    z-index: 999;
    position: sticky;
    top: 0px;

    .pc_index_head {
      width: 80%;
      margin: 0px auto;

      display: flex;
      justify-content: space-between;
      height: 44px;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      text-align: center;
      align-items: center;
      .pc_index_head_left {
        cursor: pointer;
      }
      .pc_index_head_right {
        cursor: pointer;
        height: 44px;
        display: flex;
        align-items: center;
        .avater {
          height: 36px;
          width: 36px;
          border-radius: 50%;
        }
        .avaterDiv {
          display: flex;
          align-items: center;
          position: relative;
          .select {
            width: 100px;
            height: 60px;
            position: absolute;
            bottom: -60px;
            left: 0;
            border: 1px solid #efefef;
            border-top: 0;
            font-size: 14px;
            z-index: 999;
            .personal_details {
              width: 100%;
              height: 50%;
              display: flex;
              align-items: center;
              background-color: #fff;
              justify-content: center;
            }
            .personal_details:hover {
              background-color: #d7dbe7;
              color: #3562ff;
            }
            .log_out {
              width: 100%;
              height: 50%;
              background-color: #fff;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            .log_out:hover {
              background-color: #d7dbe7;
              color: #3562ff;
            }
          }
        }
        span {
          margin-left: 12px;
        }
        // 中英切换
        .bo {
          position: relative;
          width: 50px;
          height: 25px;
          left: 30px;
          background-color: rgba(0, 0, 0, 0.3);
          border-radius: 12.5px;

          .word {
            display: flex;
            justify-content: space-between;
            color: #fff;
            height: 100%;
          }
          .word div {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50%;
            font-size: 12px;
          }
          .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            background-color: rgb(255, 255, 255);
            color: #000;
            position: absolute;
            top: 0;
            left: 0;
            width: 25px;
            height: 25px;
            border-radius: 50%;
          }
          .aas {
            left: 25px;
          }
        }
      }
    }
  }

  .pc_index_main {
    width: 80%;
    margin: 0px auto;

    .activity_btn {
      width: 30%;
      margin: 20px auto;
      .btn_status {
        // box-sizing: border-box;
        width: 70px;
        height: 35.96px;
        /* 白 */

        background: #ffffff;
        /* 主色 */

        // border: 1px solid #3562ff;
        border-radius: 4px;
        .van-button__text {
          font-size: 16px;
        }
      }
      /deep/.van-swipe-item {
        width: 100%;
      }
      .active {
        border: 1px solid #3562ff;
        color: #3562ff;
        box-shadow: 5px -3px #3562ff;
      }
    }
    .active_title {
      width: 50%;
      font-size: 16px;
      margin: 20px 0px;
    }
    .page_data {
      width: 100%;

      .activity_state {
        height: 68px;
        align-items: center;
        display: flex;
        // font-weight: 500;
        font-family: YouSheBiaoTiHei;
        font-size: 18px;
        color: #1a1a1a;
        .activity_state_item {
          padding: 0 16px;
          cursor: pointer;
        }

        .activity_state_active {
          font-size: 18px;
          // font-weight: 600;
          color: #3562ff;
        }
      }

      .page_data_item {
        // width: 360px;
        // box-sizing: border-box;
        // background-color: #fff;
        // padding-bottom: 0.2667rem;
        margin-bottom: 0.2667rem;
        // border: 0.0267rem solid #efefef;
        // margin-right: 20px;
        cursor: pointer;

        width: 25%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .item_box {
          // width: 360px;
          width: 96%;
          box-sizing: border-box;
          background-color: #fff;
          // margin-bottom: 0.2667rem;
          // border: 0.0267rem solid #efefef;
          // margin-right: 20px;
        }
        .page_data_item_img {
          width: 100%;
          overflow: hidden;
          height: 200px;
          position: relative;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;

          img {
            position: absolute;
            left: 0;
            top: 0;
            overflow: hidden;
            width: 100%;
            // height: 3.3333rem;
            height: 100%;
            // border-radius: 0.1067rem;
          }
          em {
            margin: 0 4px 0 8px;
          }
          .page_data_item_title {
            position: absolute;
            bottom: 8px;
            width: 330px;
            left: 12px;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 700;
            font-size: 14px;
            line-height: 17.78px;
            letter-spacing: 0.06em;
            color: #ffffff;
            display: -webkit-box;
            word-break: break-all;
            text-overflow: ellipsis;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          .page_data_item_kinds {
            position: absolute;
            bottom: 20%;
            width: 60%;
            left: 20%;
            font-family: 'Inter';
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 15px;

            text-align: center;

            color: #ffffff;
            span {
              display: inline-block;
              margin: 0px, 0px;
              padding: 0px, 0px;
            }
          }
          .img_number {
            position: absolute;
            bottom: 10px;
            right: 10px;
            font-size: 14px;
            color: #fff;
          }
          .mask {
            position: absolute;
            width: 100%;
            height: 3.3333rem;
            top: 0;
            left: 0;
            background: rgba(0, 0, 0, 0.5);
          }
          .mask1 {
            position: absolute;
            width: 100%;
            // height: 3.3333rem;
            height: 30%;
            bottom: 0;
            left: 0;
            // background: rgba(0, 0, 0, 0.3);
            background-image: linear-gradient(to top, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0));
            animation: mask 1s;
          }

          @keyframes mask {
            0% {
              opacity: 0;
            }

            100% {
              opacity: 1;
            }
          }
        }
        .page_data_item_organizer {
          height: 50px;
          line-height: 50px;
          font-size: 12px;
          color: #999;
          // text-align: center;
          display: flex;
          justify-content: space-between;
          .left {
            flex: 1;
            // width: 95px;
            margin-left: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .right_box {
            display: flex;
            padding-right: 10px;
            .center {
              // margin-left: 31px;
            }
            .right {
              margin-left: 14px;
            }
          }
        }
      }
      // .page_data_item:hover {
      //   box-shadow: 0px 13px 13px rgba(0, 0, 0, 0.08);
      // }
      .item_box:hover {
        box-shadow: 0px 13px 13px rgba(0, 0, 0, 0.08);
      }
    }
  }
}
</style>
